// PRD 08 §3.1 — 15 standard ICD-10 chapters. UI-only (not persisted).
// Auto-fill side effects (rangeStart/rangeEnd + name) live in the parent
// form's onChange handler so this component stays purely presentational.

import { useTranslation } from 'react-i18next';

import { ICD_CHAPTERS } from '../utils/icd-chapters';

interface IcdChapterSelectProps {
  // Single-letter key from ICD_CHAPTERS, or '' for the "Select…" prompt.
  value: string;
  onChange: (letter: string) => void;
  id?: string;
}

export function IcdChapterSelect({ value, onChange, id }: IcdChapterSelectProps) {
  const { t } = useTranslation('admin');
  return (
    <select
      id={id}
      className="form-field__select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">
        {t('diseaseCodeManagement.groupForm.fields.chapter.placeholder')}
      </option>
      {ICD_CHAPTERS.map((ch) => (
        <option key={ch.letter} value={ch.letter}>
          {ch.rangeStart}~{ch.rangeEnd}{' '}
          {t(`diseaseCodeManagement.icdChapters.${ch.letter}`)}
        </option>
      ))}
    </select>
  );
}
